import { render, staticRenderFns } from "./DuplicatedContactModal.vue?vue&type=template&id=7d36d001&"
import script from "./DuplicatedContactModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatedContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports